<template>
  <div class="callback">
    <h2 v-if="loading">🔄 Processing...</h2>
    <h2 v-else-if="success">✅ Verified! Redirecting...</h2>
    <h2 v-else>❌ Failed. Redirecting...</h2>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { supabase } from '@/supabase'

const router = useRouter()
const loading = ref(true)
const success = ref(false)

onMounted(async () => {
  const hash = window.location.hash;

  // STEP 1: Password reset link
  if (hash.includes("type=recovery")) {
    const params = new URLSearchParams(hash.substring(1));
    const access_token = params.get("access_token");
    const refresh_token = params.get("refresh_token");

    if (access_token && refresh_token) {
      await supabase.auth.setSession({ access_token, refresh_token });
    }

    success.value = true;
    loading.value = false;

    setTimeout(() => router.push("/reset-password"), 500);
    return;
  }

  // STEP 2: Normal email callback
  const { data, error } = await supabase.auth.getUser();
  loading.value = false;

  if (error || !data?.user) {
    setTimeout(() => router.push("/login"), 1500);
    return;
  }

  success.value = true;
  setTimeout(() => router.push("/"), 1000);
});

</script>

<style scoped>
.callback {
  color: white;
  text-align: center;
  margin-top: 100px;
}
</style>
